import React from "react";
import { Button, Typography } from "@mui/material";
import { Link } from "react-router";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import ProductBoxGrid from "@/src/components/ProductBoxGrid/ProductBoxGrid";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";

type ServiceWorldSendMessageBoxProps = {
  product: AbstractCase;
};

export default function ServiceWorldSendMessageBox({ product }: ServiceWorldSendMessageBoxProps) {
  return (
    <ContentBox headline={"Nachricht senden"}>
      <ProductBoxGrid
        items={[
          <Typography>Hier können Sie jederzeit direkt eine Frage stellen, weitere Details mitteilen oder uns Dokumente zusenden.</Typography>,
          <Button variant={"outlined"} fullWidth component={Link} to={`/servicewelt/nachrichten/neu?product=${product.name}&productId=${product.id}`}>
            Nachricht schreiben
          </Button>,
        ]}
      />
    </ContentBox>
  );
}
